var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Historial de Visualización")]},proxy:true}])},[_c('VideosList',[_vm._v(" Todavía no has visto ningún vídeo. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }